import React, { HTMLProps } from 'react';

import './text-area.scss';

const TextArea: React.FC<Props> = ({
    aria = true,
    className,
    dataValidation = null,
    id,
    name,
    onChange = () => {},
    resize = 'none',
    placeHolder = null,
    required = true,
    value,
    ...props
}) => {
    return (
        <textarea
            id={id || undefined}
            className={className || undefined}
            style={{ resize }}
            name={name || undefined}
            aria-required={aria}
            data-validation-isnotempty-error={dataValidation}
            placeholder={placeHolder || undefined}
            required={required}
            onChange={onChange}
            value={value}
            {...props}
        />
    );
};

interface Props extends HTMLProps<HTMLTextAreaElement> {
    aria?: boolean;
    className?: string;
    dataValidation?: string | null;
    id?: string;
    name?: string;
    onChange?: (...args: any[]) => void;
    placeHolder?: string | null;
    required?: boolean;
    resize?: 'none' | 'vertical' | 'horizontal' | 'both';
    value?: string;
}

export default TextArea;
